<div class="wrapper flex column vcenter hcenter">
  <div class="loading-text">
    {{loadingText}}
  </div>
  
  <mat-progress-spinner color="primary" mode="indeterminate" diameter="200">
  </mat-progress-spinner>
</div>